import { TextField } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

// copied validation from https://github.com/django/django/blob/1.6/django/core/validators.py#L43-50
/* eslint-disable no-useless-escape */
// the validation process should be equivalent to backend validation process
export const urlValidation = new RegExp("^(http|https)(://)(www.)?[a-zA-Z0-9-_]+\\.[a-zA-Z0-9-_]+(.[a-zA-Z]+)?", "i");

export class SwivuUrlField extends TextField {

  static get type() {
    return WIDGET_KEYS.fieldUrl;
  }

  get isValid() {
    return super.isValid && (!this.value?.trim() || urlValidation.test(this.value));
  }
}

SwivuUrlField.initClass();
